import React, { FC, useMemo } from 'react';

import ColumnTitle from '~src/modules/heatmap/components/table/column/ColumnTitle';
import { translateContent } from '~src/services/translationServices';
import {ESTopic, Topic} from '~src/interfaces/topic.interface';

import { TitleContainer, TopicRowWrapper } from './rows.sc';

interface Props {
  setContainerRef: (e: HTMLDivElement) => void;
  topics: ESTopic[];
  selectTopic: (topicId: string) => void;
  selectedTopic: string | null;
  singleTopic: Topic | null;
}

const TopicRow: FC<Props> = (props) => {
  const topics = useMemo(
    () =>
      props.topics.map((topic) => {
        return (
          <ColumnTitle
            isHidden={!!props.selectedTopic && props.selectedTopic !== topic.id}
            isFixed={!!props.selectedTopic && props.selectedTopic === topic.id}
            select={props.selectTopic}
            id={topic.id}
            text={translateContent(topic.name)}
            key={topic.id}
          />
        );
      }),
    [props.topics, props.selectedTopic],
  );

  return (
    <TopicRowWrapper>
      <TitleContainer ref={props.setContainerRef}>
        {props.topics.length > 0
          ? topics
          : props.singleTopic && (
              <ColumnTitle
                isHidden={false}
                isFixed
                select={props.selectTopic}
                id={props.singleTopic.id}
                text={translateContent(props.singleTopic.name)}
              />
            )}
      </TitleContainer>
    </TopicRowWrapper>
  );
};

export default React.memo(TopicRow);
